import type { ActivityEntry } from "../state/uiStore";

export const ACTIVITY_CATALOG: ActivityEntry[] = [
  {
    code: "DEV-FE",
    label: "Développement frontend",
    sub: "Code mission client",
    ic: "briefcase",
  },
  {
    code: "DEV-BE",
    label: "Développement backend",
    sub: "Code mission client",
    ic: "briefcase",
  },
  {
    code: "REUNION",
    label: "Réunion client",
    sub: "Atelier, comité, suivi",
    ic: "briefcase",
  },
  {
    code: "LABO",
    label: "Travaux laboratoire",
    sub: "R&D, qualité",
    ic: "tools",
  },
  {
    code: "CHANTIER",
    label: "Chantier",
    sub: "Intervention sur site",
    ic: "tools",
  },
  {
    code: "CULTURE",
    label: "Travaux culture",
    sub: "Parcelle agricole",
    ic: "tractor",
  },
  {
    code: "LIVR",
    label: "Tournée livraison",
    sub: "Transport",
    ic: "truck",
  },
  {
    code: "FORM",
    label: "Formation",
    sub: "Interne ou externe",
    ic: "briefcase",
  },
  {
    code: "ADMIN",
    label: "Administratif",
    sub: "Saisie, déclarations",
    ic: "briefcase",
  },
];
